import { render, staticRenderFns } from "./ForumContactRequest.vue?vue&type=template&id=4b5d3420&"
import script from "./ForumContactRequest.vue?vue&type=script&lang=js&"
export * from "./ForumContactRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports